module.exports = __webpack_public_path__ + "static/media/myPadilla-graphic-signup-2x.16c2db7b.png";